import React, {useState} from 'react';
import ReactTableBase from "../Table/ReactTableBase";
import {Link} from "react-router-dom";
import renderCellRating from "../Table/RenderCellRating";
import {exportToCsv} from "../../services/FileService";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import {filteredDataTabSearch} from "../../services/UtilsService";
import TableSearch from "../Table/TableSearch";

const ActiviteTypesStatsTable = ({ activiteTypes }) => {
    const data = React.useMemo(() => activiteTypes, [activiteTypes]);
    const hasEnterprise = activiteTypes.some(activiteTypes => activiteTypes.entreprise);
    const [searchQuery, setSearchQuery] = useState("");
    const handleSearch = (event) => { setSearchQuery(event.target.value);};

    const renderCellPlaces = ({ row, value }) => {
        return `${ value } / ${row.original.participantsMax}`;
    }

    const renderCellEntreprise = ({ row }) => {
        if (!row.original.entreprise) return (<div></div>);

        return (
            <div>
                { row.original.entreprise ? row.original.entreprise.nom : "" }
            </div>
        );
    }

    const renderCellAttentes = ({ row, value }) => {
        const styles = {
            padding: "5px 10px",
            borderRadius: "5px",
        }

        let classe;

        value = parseInt(value);

        if (value === 0) {
        } else if (value > 10) {
            classe = "bg1";
        } else if (value > 6) {
            classe = "bg2";
        } else if (value > 3) {
            classe = "bg3";
        } else if (value > 1) {
            classe = "bg4";
        } else if (value === 1) {
            classe = "bg5";
        } else {
            classe = "bg0";
        }

        return (
            <div>
                <span className={classe} style={styles}>{ value }</span>
            </div>
        );
    }

    const renderCellPasVenus = ({ row, value }) => {
        let classes = "etiquette ";

        // Si seance dans le futur, pas de pas venus
        //  if (new Date(row.original.date) > new Date()) {
        //      classes += " bg0";
        //      return (<div title={"Séance dans le futur"}>
        //          <span className={classes}>
        //          N/A
        //          </span>
        //      </div>);
        //  }

        const nbPasVenus = parseInt(value);
        const placesReservees = parseInt(row.original.nb_inscrits);

        // si + de 50% des inscrits ne sont pas venus
        const isBad = nbPasVenus >= (placesReservees / 2);
        const isGood = nbPasVenus === 0;
        const isAlmostGood = nbPasVenus <= (placesReservees / 10);
        const isAlmostBad = nbPasVenus <= (placesReservees / 4);
        const isHalf = nbPasVenus >= (placesReservees / 4);


        if (isGood) {

        } else if (isBad) {
            classes += "bg2";
        } else if (isAlmostBad) {
            classes += "bg3";
        } else if (isHalf) {
            classes += "bg4";
        } else if (isAlmostGood) {
            classes += "bg6";
        }

        return (
            <div>
                <span className={classes}>
                { row.original.nb_pas_venus }
                </span>
            </div>
        );
    }

    const columns = [
        {
            Header: 'Activité',
            accessor: 'label',
        },
        {
            Header: 'Nombre de séances planifiées',
            accessor: 'nb_seances_planifiees',
        },
        {
            Header: 'Nombre de séances annulées',
            accessor: 'nb_seances_annulees',
        },
        {
            Header: 'Nombre de séances terminées',
            accessor: 'nb_seances_realisees',
        },
        {
            Header: 'Nombre de places totales',
            accessor: 'nb_places_totales',
        },
        {
            Header: 'Nombre inscrits',
            accessor: 'nb_inscrits',
        },
        {
            Header: 'Nombre de présence',
            accessor: 'nb_presences',
        },
        {
            Header: 'Liste d\'attente',
            accessor: 'nb_attentes',
            Cell: renderCellAttentes
        },
        {
            Header: 'Nombre annulations',
            accessor: 'nb_annulations',
        },
        {
            Header: 'Inscrits mais pas venu',
            accessor: 'nb_pas_venus',
            Cell: renderCellPasVenus,
        },
        {
            Header: 'Satisfaction globale',
            accessor: 'satisfaction_globale',
            Cell: renderCellRating,
        },
    ];

    if (hasEnterprise) {
        columns.unshift({ // Ajout d'une colonne en début de tableau
            Header: 'Entreprise',
            accessor: 'entreprise',
            Cell: renderCellEntreprise,
        });
    }

    const handleDownloadCSV = () => {
        if (hasEnterprise) {
            activiteTypes.forEach(activiteType => {
                activiteType.entreprise = activiteType.entreprise ? activiteType.entreprise.nom : "";
            });
        }
        exportToCsv("activite_types_stats.csv", activiteTypes, columns);
    };

    const filteredData = filteredDataTabSearch(activiteTypes, columns, searchQuery);

    return (
        <>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", margin: "12px 0 12px 0", padding: "0 8px 0 0"}}>

                <TableSearch onSearch={handleSearch} value={searchQuery} />

                <button className={"btn"} style={{
                    backgroundColor: "#e7f1e6",
                    border: "2px solid var(--clr-accent)",
                    height: "fit-content",
                }} onClick={handleDownloadCSV} title={"Télécharger le tableau"}>
                    <FontAwesomeIcon icon={faDownload}/>
                </button>
            </div>

            <ReactTableBase dataSource={filteredData} columnsData={columns}/>
        </>
    )
        ;
};

export default ActiviteTypesStatsTable;
